export default "__VITE_ASSET__Bd0n8qUm__"